export default __webpack_public_path__ + "static/media/tmp_logo2.c1afa48d.png";